import type { FieldPath, FieldValues, UseFormSetValue } from 'react-hook-form';

/** Binds a text/input field: syncs both react-hook-form and context state */
export function bindTextField<T extends FieldValues>(
  fieldName: FieldPath<T>,
  setValue: UseFormSetValue<T>,
  setUserData: (field: string, value: unknown) => void
) {
  return {
    onChange: (event: { target: { value: string } }) => {
      const value = event.target.value;
      setValue(fieldName, value as never);
      setUserData(fieldName, value);
    },
  };
}

/** Binds a select/datePicker/switch: value goes directly to context (no setValue for controlled) */
export function bindValueField(
  fieldName: string,
  setUserData: (field: string, value: unknown) => void
) {
  return {
    onChange: (value: unknown) => setUserData(fieldName, value),
  };
}
